export default __webpack_public_path__ + "static/media/bg-mobile-reward.f325557c.svg";